import React, { useMemo } from 'react';

export interface AvHighlightProps {
  text: string;
  highlights?: string[];
}

const AvHighlight: React.FC<AvHighlightProps> = ({ text = '', highlights = [] }) => {
  const highlighted = useMemo(() => {
    if (!highlights.length) {
      return text;
    }
    try {
      const escaped = highlights.map(h => h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const matchRegex = RegExp(escaped.join('|'), 'ig');
      const matches = [...text.matchAll(matchRegex)];

      return text.split(matchRegex).map((segment, index, segments) => {
        const isNotLast = index + 1 !== segments.length;
        return (
          <React.Fragment key={index}>
            {segment}
            {isNotLast && <mark>{matches[index]}</mark>}
          </React.Fragment>
        );
      });
    } catch {
      return text;
    }
  }, [highlights, text]);
  return highlighted;
};

export { AvHighlight };
